<template>
    <form @submit="onSubmit" :action="`/account/booking/save/${booking.reference}`" method="post" class="max-w-7xl grid grid-cols-7 gap-6 mx-auto">
        <input type="hidden" name="_token" :value="csrf">
        <input type="hidden" name="id" :value="booking.id">
        <input type="hidden" name="entry" :value="entry">
        <input type="hidden" name="exit" :value="exit">

        <div class="col-span-7 md:col-span-5 space-y-6">
           <div class="mt-4 px-4 md:px-0">
                <div class="bg-brand-blue py-4 text-2xl text-white px-3 md:px-6">
                    <svg xmlns="http://www.w3.org/2000/svg" class="w-6 h-6 inline-block mb-1" viewBox="0 0 20 20"
                        fill="currentColor">
                        <path fill-rule="evenodd" d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z"
                            clip-rule="evenodd" />
                    </svg>

                    Personal Information
                </div>
                <div class="bg-white p-8 border-b-2 border-gray-300 border-opacity-70">
                    <div class="grid grid-cols-4 gap-6">
                        <div class="col-span-4 md:col-span-2">
                            <text-input
                                label="First name"
                                autocomplete="given-name"
                                name="first_name"
                                v-model="first_name"
                            ></text-input>

                        </div>

                        <div class="col-span-4 md:col-span-2">
                            <text-input
                                label="Last name"
                                autocomplete="family-name"
                                :validation="v$.last_name"
                                name="last_name"
                                v-model="last_name"
                            ></text-input>
                        </div>

                        <div class="md:col-start-1 col-span-4 md:col-span-2">
                            <text-input
                                label="Email address"
                                autocomplete="email"
                                :validation="v$.email"
                                name="email"
                                v-model="email"
                            ></text-input>

                        </div>

                        <div class="col-span-4 md:col-span-2">
                            <text-input
                                label="Phone number"
                                autocomplete="telephone"
                                name="phone"
                                v-model="phone"
                            ></text-input>

                        </div>

                        <div class="col-span-4 md:col-span-2">
                            <text-input
                                label="Party size"
                                type="number"
                                :validation="v$.party_size"
                                name="party_size"
                                v-model="v$.party_size.$model"
                            ></text-input>

                        </div>
                    </div>
                </div>
            </div>

            <div class="mt-12">
                <div class="bg-brand-blue py-4 text-2xl text-white px-6">
                    <i class="fas fa-calendar"></i>

                    Change Dates
                </div>
                <div class="bg-white p-4 border-b-2 border-gray-300 border-opacity-70">
                    <div class="grid grid-cols-12 gap-2 mt-4">
                        <div class="col-span-12 sm:col-span-4">
                            <label for="entry_date" class="block text-lg font-medium">
                                Arrive at carpark:
                            </label>
                            <div class="mt-1">
                                <div class="mt-1 relative rounded-md shadow-sm">
                                    <DatePicker v-model="entryDate" mode="date" color="orange" :masks="masks" :min-date='new Date()' :attributes="attributes" locale="en-GB"
                                        :popover="{ visibility: 'click' }">
                                        <template v-slot="{ inputValue, inputEvents }">
                                            <input type="text" id="entry_date"
                                                class="focus:ring-indigo-500 focus:border-indigo-500 block w-full pr-10 pl-2 border-gray-300 sm:text-lg rounded-md py-2"
                                                :value="inputValue" v-on="inputEvents"
                                                readonly />
                                        </template>
                                    </DatePicker>
                                    <div class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
                                        <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                                d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z">
                                            </path>
                                        </svg>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-span-12 sm:col-span-2">
                            <div>
                                <label class="hidden sm:block text-lg text-white font-medium">&nbsp;</label>
                                <div class="mt-1">
                                    <div class="mt-1 relative rounded-md shadow-sm">
                                        <select id="entry_time" style="background-image: none"
                                            class="appearance-none mt-1 block w-full pl-3 pr-10 text-gray-600 border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-lg rounded-md py-2"
                                            v-model="entryTime">
                                            <option v-for="n in timeList" :key="n" :value="n">{{ n }}</option>
                                        </select>
                                        <div class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
                                            <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"
                                                xmlns="http://www.w3.org/2000/svg">
                                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                                    d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                                            </svg>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="grid grid-cols-12 gap-2 mt-4">
                        <div class="col-span-12 sm:col-span-4">
                            <label for="exit_date" class="block text-lg font-medium">
                                Return to carpark:
                            </label>
                            <div class="mt-1">
                                <div class="mt-1 relative rounded-md shadow-sm">
                                    <DatePicker v-model="exitDate" mode="date" color="orange" :masks="masks" :min-date='minExitDate' :attributes="attributes" locale="en-GB"
                                        :popover="{ visibility: 'click' }">
                                        <template v-slot="{ inputValue, inputEvents }">
                                            <input type="text" id="exit_date"
                                                class="focus:ring-indigo-500 focus:border-indigo-500 block w-full pr-10 pl-2 border-gray-300 sm:text-lg rounded-md py-2"
                                                :value="inputValue" v-on="inputEvents"
                                                readonly />
                                        </template>
                                    </DatePicker>
                                    <div class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
                                        <!-- Heroicon name: calendar -->
                                        <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                                d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z">
                                            </path>
                                        </svg>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-span-12 md:col-span-2">
                            <div>
                                <label class="hidden sm:block text-lg text-white font-medium">&nbsp;</label>
                                <div class="mt-1">
                                    <div class="mt-1 relative rounded-md shadow-sm">
                                        <select id="exit_time" style="background-image: none"
                                            class="appearance-none mt-1 block w-full pl-3 pr-10 text-gray-600 border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-lg rounded-md py-2"
                                            v-model="exitTime">
                                            <option v-for="n in timeList" :key="n" :value="n">{{ n }}</option>
                                        </select>
                                        <div class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
                                            <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"
                                                xmlns="http://www.w3.org/2000/svg">
                                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                                    d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                                            </svg>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="mt-12">
                <div class="bg-brand-blue py-4 text-2xl text-white px-6">
                    <i class="fas fa-plane"></i>

                    Flight Information
                </div>
                <div class="bg-white p-8 border-b-2 border-gray-300 border-opacity-70">
                    <div class="grid grid-cols-4 gap-6">
                        <div class="col-span-4 md:col-span-2">
                            <text-input
                                label="Returning flight number"
                                v-model="returning_flight_number"
                                name="returning_flight_number"
                                styling="uppercase"
                            ></text-input>
                        </div>

                        <div class="col-span-4 md:col-span-2">
                            <text-input
                                label="Destination"
                                v-model="destination"
                                name="destination"
                                styling="capitalize"
                            ></text-input>
                        </div>
                    </div>
                </div>
            </div>

            <div class="mt-12">
                <div class="bg-brand-blue py-4 text-2xl text-white px-6">
                    <i class="fas fa-car"></i>

                    Vehicle Information
                </div>
                <div class="bg-white p-4 md:p-8">
                    <div class="grid grid-cols-4 gap-6">
                        <div class="col-span-4 md:col-span-2">
                            <TextInput
                                label="Vehicle Registration"
                                autocomplete="off"
                                styling="uppercase"
                                name="vehicle_registration"
                                v-model="vehicle_registration"
                            ></TextInput>
                        </div>
                        <div class="col-span-4 md:col-span-2">
                            <div class="relative mt-5">
                                <select name="vehicle_type_id" v-model="vehicle_type_id" :disabled="!booking.is_amendable" class="peer h-11 w-full border-b-2 border-gray-300 text-gray-900 placeholder-transparent focus:outline-none focus:border-ap-primary">
                                    <option v-for="type in vehicleTypes" :key="type.id" :value="type.id">{{ type.name }}</option>
                                </select>
                                <label class="absolute left-0 -top-3.5 text-gray-600 text-sm transition-all peer-placeholder-shown:text-base peer-placeholder-shown:text-gray-400 peer-placeholder-shown:top-2 peer-focus:-top-3.5 peer-focus:text-gray-600 peer-focus:text-sm">Vehicle Type</label>
                            </div>
                        </div>
                        <div class="col-span-4 md:col-span-2">

                            <DataListInput
                                label="Vehicle Make"
                                v-model="vehicle_make"
                                name="vehicle_make"
                                :options="vehicleMakeList"
                                option-slug="vehicle-make-list"
                            ></DataListInput>
                        </div>

                        <div class="col-span-4 md:col-span-2">
                            <text-input
                                label="Vehicle Colour"
                                autocomplete="off"
                                name="vehicle_colour"
                                v-model="vehicle_colour"
                            ></text-input>
                        </div>

                    </div>
                </div>
            </div>
        </div>
        <div class="col-span-7 md:col-span-2 space-y-6">
            <div class="mt-4">
                <SummaryCard
                    :booking="booking"
                    :entry="entry"
                    :exit="exit"
                    :payment-due="payment_due"
                    :vehicle-type-id="vehicle_type_id"
                    :vehicle-registration="vehicle_registration"
                    :party-size="party_size"
                    :valet="valet"
                    :show-save-btn="true"

                    @priceUpdate="(value) => payment_due = value"
                ></SummaryCard>
            </div>
        </div>
    </form>

    <!-- <popup-modal
        :show="showPopupModal"
        :success="false"
        title="Error"
        :message="errorMessage"

        @close="showPopupModal = false"
    ></popup-modal> -->
</template>

<script>
import axios from 'axios';
import { DatePicker } from 'v-calendar';
import moment from 'moment';
import useVuelidate from '@vuelidate/core';
import {
    required,
    email,
    helpers,
    minValue,
} from '@vuelidate/validators';
import TextInput from '../TextInput.vue';
import DataListInput from '../DataListInput.vue';
import EditBookingSummaryCard from './Booking/EditBookingSummaryCard.vue';
import PopupModal from './PopupModal.vue';

const { withMessage } = helpers;

export default {
    setup() {
        return {
            v$: useVuelidate(),
        };
    },
    data() {
        return {
            first_name: this.booking.customer.first_name,
            last_name: this.booking.customer.last_name,
            email: this.booking.customer.email,
            phone: this.booking.customer.phone,
            party_size: this.booking.party_size,
            entryDate: null,
            entryTime: null,
            exitDate: null,
            exitTime: null,
            returning_flight_number: this.booking.returning_flight_number,
            destination: this.booking.destination,
            vehicle_registration: this.booking.vehicle_registration,
            vehicle_type_id: this.booking.vehicle_type_id,
            vehicle_make: this.booking.vehicle_make,
            vehicle_colour: this.booking.vehicle_colour,
            timeList: [],
            csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
            saveBtnText: 'Update Booking',
            valet: this.booking.valet,
            masks: {
                input: 'DD-MM-YYYY',
            },
            payment_due: this.booking.payment_due,
        };
    },
    validations() {
        return {
            first_name: {
                required: withMessage('First name is required', required),
            },
            last_name: {
                required: withMessage('Last name is required', required),
            },
            email: {
                required: withMessage('Email address is required', required),
                email: withMessage('Not a valid email', email),
            },
            party_size: {
                required: withMessage('Party size is required', required),
                minValue: withMessage('You need at least one passenger', minValue(1)),
            },
            entry: {
                required: withMessage('Arrival date is required', required),
            },
            exit: {
                required: withMessage('Return date is required', required),
            },
        };
    },
    components: {
        TextInput,
        DatePicker,
        SummaryCard: EditBookingSummaryCard,
        DataListInput,
    },
    computed: {
        entry() {
            if (this.entryDate === null) return null;

            const timestamp = moment(this.entryDate).format('YYYY-MM-DD');
            console.log(`${timestamp} ${this.entryTime}`);
            return moment(`${timestamp} ${this.entryTime}`).format('YYYY-MM-DD HH:mm:ss');
        },
        exit() {
            if (this.exitDate == null) return null;

            const timestamp = moment(this.exitDate).format('YYYY-MM-DD');
            return moment(`${timestamp} ${this.exitTime}`).format('YYYY-MM-DD HH:mm:ss');
        },
        minExitDate() {
            const date = new Date();
            if (!this.entryDate) return date;

            return this.entryDate;
        },
        attributes() {
            let dates = null;
            if (this.entryDate == null && this.exitDate == null) return null;

            if (this.entryDate != null && this.exitDate == null) {
                dates = this.entryDate;
            }

            if (this.exitDate == null && this.exitDate != null) {
                dates = this.exitDate;
            }

            if (this.exitDate != null && this.exitDate != null) {
                dates = {
                    start: this.entryDate,
                    end: this.exitDate,
                };
            }

            if (this.entryDate > this.exitDate) return null;

            return [{
                highlight: true,
                dates,
            }];
        },
    },
    props: {
        booking: { type: Object, required: true },
        vehicleTypes: { type: Object, required: true },
    },
    watch: {
        entry(value, old) {
            if (old === null) return;

            // this.calculatePriceChange();
        },
        exit(value, old) {
            if (old === null) return;

            // this.calculatePriceChange();
        },
        vehicle_type_id() {
            // this.calculatePriceChange();
        },
    },
    methods: {
        async onSubmit(e) {
            const result = await this.v$.$validate();

            if (!result) {
                e.preventDefault();
                return false;
            }

            return true;
        },
        generateTimeDropdownOptions() {
            const current = moment().subtract(1, 'days').startOf('day');

            for (let i = 0; i < 96; i += 1) {
                this.timeList.push(current.format('HH:mm'));
                current.add(15, 'minutes');
            }
        },
        prefillDateInputs() {
            const dateTimeEntry = this.booking.entry;

            const dateTimePartsEntry = dateTimeEntry.split(/[- :]/);
            dateTimePartsEntry[1] -= 1;

            this.entryDate = new Date(...dateTimePartsEntry);
            this.entryTime = `${dateTimePartsEntry[3]}:${dateTimePartsEntry[4]}`;

            const dateTimeExit = this.booking.exit;
            const dateTimePartsExit = dateTimeExit.split(/[- :]/);
            dateTimePartsExit[1] -= 1;

            this.exitDate = new Date(...dateTimePartsExit);
            this.exitTime = `${dateTimePartsExit[3]}:${dateTimePartsExit[4]}`;
        },
    },
    mounted() {
        this.generateTimeDropdownOptions();
        this.prefillDateInputs();
    },
};
</script>

<style scoped>

select[disabled] { @apply bg-gray-200 }

</style>
